import { render, staticRenderFns } from "./Organizationalstructure.vue?vue&type=template&id=5a71618c&scoped=true"
import script from "./Organizationalstructure.vue?vue&type=script&lang=js"
export * from "./Organizationalstructure.vue?vue&type=script&lang=js"
import style0 from "./Organizationalstructure.vue?vue&type=style&index=0&id=5a71618c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a71618c",
  null
  
)

export default component.exports